const fundamentalsRoutes = [
  {
    path: '/fundamentos/cor',
    type: 'fundamentos',
    url: 'fundamentos',
    doc: 'cor',
  },
  {
    path: '/fundamentos/design-token',
    type: 'fundamentos',
    url: 'fundamentos',
    doc: 'design-token',
  },
  {
    path: '/fundamentos/espacamento',
    type: 'fundamentos',
    url: 'fundamentos',
    doc: 'espacamento',
  },
  {
    path: '/fundamentos/iconografia',
    type: 'fundamentos',
    url: 'fundamentos',
    doc: 'iconografia',
  },
  {
    path: '/fundamentos/movimento',
    type: 'fundamentos',
    url: 'fundamentos',
    doc: 'movimento',
  },
  {
    path: '/fundamentos/grid',
    type: 'fundamentos',
    url: 'fundamentos',
    doc: 'grid',
  },
  {
    path: '/fundamentos/elevacao',
    type: 'fundamentos',
    url: 'fundamentos',
    doc: 'elevacao',
  },
  {
    path: '/fundamentos/tipografia',
    type: 'fundamentos',
    url: 'fundamentos',
    doc: 'tipografia',
  },
  {
    path: '/fundamentos/superficie',
    type: 'fundamentos',
    url: 'fundamentos',
    doc: 'superficie',
  },
  {
    path: '/fundamentos/estado',
    type: 'fundamentos',
    url: 'fundamentos',
    doc: 'estado',
  },
  {
    path: '/fundamentos/ilustracao',
    type: 'fundamentos',
    url: 'fundamentos',
    doc: 'ilustracao',
  },
  {
    path: '/padroes/tema',
    type: 'padrões',
    url: 'padroes',
    doc: 'tema',
  },
  {
    path: '/padroes/writing',
    type: 'padrões',
    url: 'padroes',
    doc: 'writing',
  },
  {
    path: '/padroes/densidade',
    type: 'padrões',
    url: 'padroes',
    doc: 'densidade',
  },
  {
    path: '/padroes/internacionalizacao',
    type: 'padrões',
    url: 'padroes',
    doc: 'internacionalizacao',
  },
  {
    path: '/padroes/sign-in',
    type: 'padrões',
    url: 'padroes',
    doc: 'sign-in',
  },
  {
    path: '/padroes/skeleton-screen',
    type: 'padrões',
    url: 'padroes',
    doc: 'skeleton-screen',
  },
  {
    path: '/padroes/collapse',
    type: 'padrões',
    url: 'padroes',
    doc: 'collapse',
  },
  {
    path: '/padroes/dropdown',
    type: 'padrões',
    url: 'padroes',
    doc: 'dropdown',
  },
  {
    path: '/padroes/content-overflow',
    type: 'padrões',
    url: 'padroes',
    doc: 'content-overflow',
  },
  {
    path: '/padroes/dados-ausentes',
    type: 'padrões',
    url: 'padroes',
    doc: 'dados-ausentes',
  },
  {
    path: '/padroes/design-conversacional',
    type: 'padrões',
    url: 'padroes',
    doc: 'design-conversacional',
  },
  {
    path: '/padroes/formulario',
    type: 'padrões',
    url: 'padroes',
    doc: 'formulario',
  },
  {
    path: '/padroes/slot-de-composicao',
    type: 'padrões',
    url: 'padroes',
    doc: 'slot-de-composicao',
  },
  {
    path: '/componentes/avatar',
    type: 'componentes',
    url: 'componentes',
    doc: 'avatar',
  },
  {
    path: '/componentes/breadcrumbs',
    type: 'componentes',
    url: 'componentes',
    doc: 'breadcrumbs',
  },
  {
    path: '/componentes/button',
    type: 'componentes',
    url: 'componentes',
    doc: 'button',
  },
  {
    path: '/componentes/card',
    type: 'componentes',
    url: 'componentes',
    doc: 'card',
  },
  {
    path: '/componentes/chat-bubble',
    type: 'componentes',
    url: 'componentes',
    doc: 'chat-bubble',
  },
  {
    path: '/componentes/chat-input',
    type: 'componentes',
    url: 'componentes',
    doc: 'chat-input',
  },
  {
    path: '/componentes/checkbox',
    type: 'componentes',
    url: 'componentes',
    doc: 'checkbox',
  },
  {
    path: '/componentes/checkbox-group',
    type: 'componentes',
    url: 'componentes',
    doc: 'checkbox-group',
  },
  {
    path: '/componentes/divider',
    type: 'componentes',
    url: 'componentes',
    doc: 'divider',
  },
  {
    path: '/componentes/footer',
    type: 'componentes',
    url: 'componentes',
    doc: 'footer',
  },
  {
    path: '/componentes/form-label',
    type: 'componentes',
    url: 'componentes',
    doc: 'form-label',
  },
  {
    path: '/componentes/header',
    type: 'componentes',
    url: 'componentes',
    doc: 'header',
  },
  {
    path: '/componentes/icon',
    type: 'componentes',
    url: 'componentes',
    doc: 'icon',
  },
  {
    path: '/componentes/institutional-bar',
    type: 'componentes',
    url: 'componentes',
    doc: 'institutional-bar',
  },
  {
    path: '/componentes/input',
    type: 'componentes',
    url: 'componentes',
    doc: 'input',
  },
  {
    path: '/componentes/list',
    type: 'componentes',
    url: 'componentes',
    doc: 'list',
  },
  {
    path: '/componentes/loading',
    type: 'componentes',
    url: 'componentes',
    doc: 'loading',
  },
  {
    path: '/componentes/message',
    type: 'componentes',
    url: 'componentes',
    doc: 'message',
  },
  {
    path: '/componentes/select',
    type: 'componentes',
    url: 'componentes',
    doc: 'select',
  },
  {
    path: '/componentes/side-menu',
    type: 'componentes',
    url: 'componentes',
    doc: 'side-menu',
  },
  {
    path: '/componentes/skip-link',
    type: 'componentes',
    url: 'componentes',
    doc: 'skip-link',
  },
  {
    path: '/componentes/radio-group',
    type: 'componentes',
    url: 'componentes',
    doc: 'radio-group',
  },
  {
    path: '/componentes/rating',
    type: 'componentes',
    url: 'componentes',
    doc: 'rating',
  },
  {
    path: '/componentes/tag',
    type: 'componentes',
    url: 'componentes',
    doc: 'tag',
  },
  {
    path: '/componentes/text',
    type: 'componentes',
    url: 'componentes',
    doc: 'text',
  },
  {
    path: '/componentes/tooltip',
    type: 'componentes',
    url: 'componentes',
    doc: 'tooltip',
  },
]

export default fundamentalsRoutes
